export default "__VITE_ASSET__1748347c__"